export type ReplayEventSink = (events: unknown[]) => void;

export interface ReplayEventBuffer {
  push(events: unknown[]): void;
  /** Hands over everything buffered so far, then streams. Returns detach. */
  attach(sink: ReplayEventSink): () => void;
  clear(): void;
}

/**
 * Sits between the socket and the replayer: the first full snapshot usually
 * arrives while the replay stage (and rrweb) is still loading, so events are
 * held until a sink attaches. Beyond `maxPending` the oldest are dropped.
 */
export const createReplayEventBuffer = (
  maxPending = 10_000
): ReplayEventBuffer => {
  let sink: ReplayEventSink | null = null;
  let pending: unknown[] = [];

  return {
    push(events) {
      if (sink) {
        sink(events);
        return;
      }
      pending = pending.concat(events).slice(-maxPending);
    },
    attach(nextSink) {
      sink = nextSink;
      const buffered = pending;
      pending = [];
      if (buffered.length) nextSink(buffered);
      return () => {
        if (sink === nextSink) sink = null;
      };
    },
    clear() {
      pending = [];
    }
  };
};
